import React from 'react';
import {
  Box,
  IconButton,
  Typography,
  Paper,
  CircularProgress
} from '@mui/material';
import { Save, X, Edit, Trash2 } from 'lucide-react';
import BlockTreePopover from './BlockTreePopover';
import PartsSelector from './PartsSelector';
import { isReadOnly } from '../../../utils/permissionUtils';

const ScopeItem = ({
  scope,
  index,
  data,
  onSave,
  onCancel,
  onEdit,
  onDelete,
  onBlockSelection,
  onPartChange,
  onSelectedItemsChange,
  updateScope
}) => {
  const getTrackerRowCount = (selectedItems) => {
    if (!selectedItems || selectedItems.size === 0) {
      return 0;
    }
    return Array.from(selectedItems).filter(item => item.startsWith('row-')).length;
  };

  const getScopeDisplayName = (scope, index) => {
    return `Scope ${index + 1}`;
  };

  const handleBlockSelection = (output) => {
    onBlockSelection(scope.id, output);
  };

  const handlePartChange = (selectedBomIds) => {
    onPartChange(scope.id, selectedBomIds);
  };

  const handleSelectedItemsChange = (newSelectedItems) => {
    onSelectedItemsChange(scope.id, newSelectedItems);
  };

  const handleSave = () => {
    onSave(scope.id);
  };

  const handleCancel = () => {
    onCancel(scope.id);
  };

  const handleEdit = () => {
    onEdit(scope.id);
  };

  const handleDelete = () => {
    onDelete(scope.id);
  };

  return (
    <Paper key={scope.id} sx={{ padding: 2, mb: 1 }} variant="outlined">
      <Typography fontSize={20} fontWeight={600}>
        {getScopeDisplayName(scope, index)}
      </Typography>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          mt: 1
        }}
      >
        <Box sx={{ flex: 1 }}>
          <BlockTreePopover
            data={data}
            onApply={handleBlockSelection}
            selectedItems={scope.selectedItems}
            setSelectedItems={handleSelectedItemsChange}
            disabled={!scope.editing || !scope.isPopoverEnabled || scope.isLoadingDropdownData}
            getTrackerRowCount={getTrackerRowCount}
            count={scope.partCount}
          />
          {scope.isLoadingDropdownData && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              Loading dropdown data...
            </Typography>
          )}
        </Box>

        <Box sx={{ flex: 1 }}>
          <PartsSelector
            scope={scope}
            onPartChange={handlePartChange}
            updateScope={updateScope}
          />
        </Box>

        {scope.editing ? (
          <Box>
            <IconButton
              disabled={scope.isLoadingButton || scope.isLoadingDropdownData}
              onClick={handleSave}
              color="success"
            >
              {scope.isLoadingButton ? (
                <CircularProgress size={18} />
              ) : (
                <Save size={18} />
              )}
            </IconButton>
            <IconButton onClick={handleCancel} color="error">
              <X size={18} />
            </IconButton>
          </Box>
        ) : (
          <Box>
            <IconButton
              onClick={handleEdit}
              color="info"
              disabled={scope.isLoadingDropdownData || scope.isLoadingDelete ||isReadOnly()}
            >
              <Edit size={18} />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              disabled={scope.isLoadingDelete || scope.isLoadingDropdownData ||isReadOnly()}
            >
              {scope.isLoadingDelete ? (
                <CircularProgress size={18} />
              ) : (
                <Trash2 size={18} />
              )}
            </IconButton>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default ScopeItem;